module.exports = __webpack_public_path__ + "static/img/sand_11_max_2.f990baed.png";